// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"infoPoint_infoBox__LX_oy","title":"infoPoint_title__2_77V","text":"infoPoint_text__3unWc","imageWrapper":"infoPoint_imageWrapper__3aJNd"};